// window.addEventListener("load", function () {
//   const el = document.getElementById("page-loader");
//   if (!el) return;
//   el.style.opacity = "0";
//   setTimeout(() => el.remove(), 300);
// });

(function () {
  function hide() {
    var el = document.getElementById('page-loader');
    if (!el) return;
    el.style.transition = 'opacity .25s';
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 280);
  }
  // Hide immediately when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hide(); });
  } else {
    hide();
  }
  window.addEventListener('load', hide);
  setTimeout(hide, 300);
  setTimeout(hide, 800);
})();